import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox", "fill", "width", "height"]
const _hoisted_2 = ["d"]

import { toRefs } from 'vue';
type SvgProps = {
  fill?: string,
  width?: string,
  height?: string,
  icon?: string,
  viewBox?: string,
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VSvgComponent',
  props: {
    fill: { default: 'dark' },
    width: { default: '24px' },
    height: { default: '24px' },
    icon: {},
    viewBox: { default: '0 0 24 24' }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const click = () => emit('click');

const props = __props;

const { fill, width, height, icon, viewBox } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "hover:cursor-pointer",
    viewBox: _unref(viewBox),
    fill: _unref(fill),
    width: _unref(width),
    height: _unref(height),
    onClick: click
  }, [
    (_unref(icon))
      ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
          _createElementVNode("path", { d: _unref(icon) }, null, 8, _hoisted_2)
        ])
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 8, _hoisted_1))
}
}

})